export const COLORS = {
  PAGE_BG: '#000'
}